import { USER_INFO, getLogoutUrlWithRedirect } from "../constants/Constants";
import { AUTH_ENVS, getAuthEnv } from "../constants/authEnvs";
import Cookies from "js-cookie";
import { decodeUserInfo } from "./userInfoEncoding";

// Each auth environment's portal uses its own cookie names on the shared
// domain (SID-2662), so every read, write and removal goes through the user's
// environment; the build's first environment when there is none yet.
const envOrDefault = (env) => env ?? getAuthEnv() ?? AUTH_ENVS[0];

export const saveUserInfo = (data) => {
  localStorage.setItem(USER_INFO, data);
};

export const getUserInfo = () =>
  decodeUserInfo(localStorage.getItem(USER_INFO));

export const getJwtToken = (env) => Cookies.get(envOrDefault(env).jwtKey);

export const getRefreshToken = (env) => Cookies.get(envOrDefault(env).refreshKey);

export const saveUserToken = (token, expiry, env) => {
  Cookies.set(envOrDefault(env).jwtKey, token, {
    domain: getCookieDomainSafe(),
    secure: true,
    sameSite: "Lax",
    // expires: new Date(expiry),
  });
};

export const saveRefreshToken = (token, expiry, env) => {
  Cookies.set(envOrDefault(env).refreshKey, token, {
    domain: getCookieDomainSafe(),
    secure: true,
    sameSite: "Lax",
    expires: new Date(expiry),
  });
};

export const cookiesCleanup = (env) => {
  const authEnv = envOrDefault(env);
  Cookies.remove(authEnv.jwtKey, {
    domain: getCookieDomainSafe(),
    path: "/",
  });
  Cookies.remove(authEnv.refreshKey, {
    domain: getCookieDomainSafe(),
    path: "/",
  });
  localStorage.removeItem(USER_INFO);
};

// Logs out at the portal the user signed in at. The environment is read before
// its cookies are removed (afterwards only the remembered environment tells).
export const logOutToPortal = () => {
  const authEnv = envOrDefault();
  const logoutUrl = getLogoutUrlWithRedirect(authEnv);
  cookiesCleanup(authEnv);
  window.location.replace(logoutUrl);
};

export const getCookieDomainSafe = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  if (hostname === "localhost" || parts.length < 2) {
    return hostname;
  }

  return "." + parts.slice(-2).join("."); // e.g., .advancedcompliance.tech
};
